module.exports = __webpack_public_path__ + "static/media/youtube-banner.42942e88.jpg";